import { Core } from "@faire/design-tokens";
import { ISuggestionEntryMixin } from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/Interfaces";
import { Opacity } from "@faire/web/slate/Color";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import * as React from "react";
import styled, { css } from "styled-components";

const itemCss = css`
  height: 44px;
  padding: 7px 16px;

  font-size: 16px;

  cursor: pointer;

  &:hover,
  &:focus {
    background-color: ${Core.surface.subdued + Opacity.O_50};
  }

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;

  ${responsiveMediaQueries.tabletAndAbove} {
    font-size: 12px;
  }
  ${responsiveMediaQueries.mobile} {
    padding: 9px 21px 8px 21px;
    margin-bottom: 1px;
  }
`;

const ListItem = styled.li`
  ${itemCss}
`;

interface Props {
  children?: React.ReactNode | undefined;
  suggestion: ISuggestionEntryMixin;
  index: number;
  onHover?: (index: number) => void;
  onClick?: (suggestion: ISuggestionEntryMixin) => void;
  onMouseLeave?: () => void;
}

export const ResultDropdownItem: React.FC<Props> = ({
  index,
  suggestion,
  onHover,
  onMouseLeave,
  onClick,
  children,
}) => (
  <ListItem
    onMouseEnter={() => onHover?.(index)}
    onClick={() => onClick?.(suggestion)}
    onMouseLeave={onMouseLeave}
    tabIndex={-1}
  >
    {children}
  </ListItem>
);
